"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.FILES = void 0;
const files_json_1 = __importDefault(require("../generator/files.json"));
exports.FILES = files_json_1.default;
